import { CollectionBase } from '@/domain/types/collections';
import { Link } from 'react-router-dom';
import PublicationCard from './publication-card';

interface SectionSummaryProps {
  label: string;
  path: string;
  collection: string;
  items: CollectionBase[];
}

const SectionSummary: React.FC<SectionSummaryProps> = ({
  label,
  path,
  collection,
  items,
}) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex justify-between items-center">
        <h2 className="text-base font-semibold text-gray-700">{label}</h2>
        <Link
          to={`/dashboard/${path}`}
          className="text-sm text-blue-600 hover:text-blue-800 font-medium"
        >
          Ver todos
        </Link>
      </div>

      {items.length === 0 ? (
        <p className="text-sm text-gray-400 italic">
          No hay publicaciones recientes
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item) => (
            <PublicationCard
              key={item.id ?? ''}
              id={item.id ?? ''}
              title={item.title}
              image={item.image}
              category={(item as CollectionBase & { category?: string }).category}
              collection={collection}
              createdAt={item.createdAt?.seconds != null ? { seconds: item.createdAt.seconds } : null}
              detailPath={`/dashboard/${path}/details/${item.id}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SectionSummary;
